<script>
    import { onMount, onDestroy } from 'svelte'
    import { fly, crossfade, slide } from 'svelte/transition'
    import { flip } from 'svelte/animate'
    import { is_function } from 'svelte/internal'
    import { circOut } from 'svelte/easing'
    import { scrollToTop } from '../../js/hash-scroll.js'
    import { flyModified } from '../../js/transitions.js'
    import { pubsConfig } from '../../store.js'
    import Publication from '../content-types/Publication.svelte'

    export let page

    $: publications = page.publications
        .filter(publication => searchFilter(publication, $pubsConfig.searchTerms))
        .filter(publication => categoriesFilter(publication, $pubsConfig.filterBy))
        .sort((a, b) => compare(a, b))

    function compare (a, b) {
        return b.pubDate.localeCompare(a.pubDate)
    }

    function searchFilter (pub, searchTerms) {
        const terms = searchTerms.map(t => t.toLowerCase())
        // check if article's title, authors, or abstract content contains term
        return terms.every(term => {
            return [pub.title, pub.authors, pub.abstract]
                .map(content => content.toLowerCase())
                .reduce(
                    (priorContainsTerm, content) =>
                        priorContainsTerm || content.includes(term),
                    false
                )
        })
    }

    function categoriesFilter (publication, filterBy) {
        // check if article's categories contain filter terms
        const pubCategories = publication.categories.map(c => c.title)
        return filterBy.every(term => pubCategories.includes(term))
    }

    function resetPubs () {
        pubsConfig.update(config => {
            return { searchTerms: [], filterBy: [] }
        })
    }

    const [send, receive] = crossfade({
        duration: d => Math.sqrt(d * 200),

        fallback (node, params) {
            const style = getComputedStyle(node)
            const transform = style.transform === 'none' ? '' : style.transform

            return {
                duration: 600,
                easing: circOut,
                css: t => `
                    transform: ${transform} scale(${t});
                    opacity: ${t};
                    position: relative;`
            }
        }
    })

    onMount(() => {
        scrollToTop()
    })

    onDestroy(() => {
        resetPubs()
    })
</script>

<div id="pubsContent" out:flyModified={{ y: 10, duration: 400, position: 'absolute' }}>
    {#if publications.length > 0}
        {#each publications as publication, index (publication.articleID)}
            <Publication {publication} color={page.circuit_color} />
        {/each}
    {:else}
        <div class="emptyMessage" in:fly={{ y: -20, duration: 1000, delay: 500 }}>
            <p>
                No publications match your selections.
                <a href={'javascript:void(0)'} on:click={resetPubs}>
                    Show all publications
                </a>
            </p>
        </div>
    {/if}
</div>

<style lang="scss">
    @import "../../styles/vars";

    #pubsContent {
        box-sizing: border-box;
        position: relative;
        width: 50vw;
        margin: 50px 25vw;
        top: 0;
    }

    .emptyMessage {
        position: relative;
        margin: 0;
        padding-bottom: 2rem;

        &::after {
            content: "";
            display: block;
            width: 200px;
            height: 2px;
            background-color: black;
            margin-top: 2rem;
        }
    }

    @include respond-to(phone) {
        #pubsContent {
            width: 92%;
            margin: 0 4% 50px;
        }
    }
</style>
